import { Directive } from '@angular/core';
import { AppContext } from '@farris/devkit';
import { GridComponent } from '@progress/kendo-angular-grid';
import { AbstractEndEdit } from './abstract_end_edit';

@Directive({
  selector: '[kendo-grid-end-edit]'
})
class KendoGridEndEditDirective extends AbstractEndEdit {
  constructor(protected appContext: AppContext, private grid: GridComponent) {
    super(appContext);
  }
  public endEdit(message: any) {
    if (this.grid && typeof this.grid.closeCell === 'function') {
      this.grid.closeCell();
    }
  }
}
export { KendoGridEndEditDirective };
